import React from 'react';

export default ({ className }) => (
  <svg className={className} viewBox='0 0 30 30' fill='none'>
    <path
      fill='currentColor'
      d='M28.6,6.3l-5-5c-0.6-0.6-1.7-0.6-2.3,0l-20,20c-0.6,0.6-0.6,1.7,0,2.3l5,5c0.3,0.3,0.7,0.5,1.2,0.5c0.4,0,0.8-0.2,1.2-0.5
        l20-20C29.3,8,29.3,7,28.6,6.3z M27.9,7.9l-20,20c-0.2,0.2-0.6,0.2-0.8,0l-5-5c-0.2-0.2-0.2-0.6,0-0.8l1.5-1.5l1.8,1.8
        c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8l-1.8-1.8l1.9-1.9l2.9,2.9C9.3,20.9,9.4,21,9.6,21
        c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8l-2.9-2.9L9,15.2l1.8,1.8c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2
        c0.2-0.2,0.2-0.6,0-0.8l-1.8-1.8l1.9-1.9l2.9,2.9c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8l-2.9-2.9
        l1.9-1.9l1.8,1.8c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8L15.2,9l1.9-1.9L20,10
        c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8l-2.9-2.9l1.9-1.9l1.8,1.8c0.1,0.1,0.2,0.2,0.4,0.2
        c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8l-1.8-1.8l1.5-1.5C22.2,2,22.4,2,22.5,2c0.1,0,0.3,0.1,0.4,0.2l5,5
        C28.1,7.3,28.1,7.7,27.9,7.9z'
    />
  </svg>
);
